require('./closest')
require('./array-from')

const {bind} = require('./bind')

bind(document, 'click', (e) => {
  if (e.target.closest('.js-toggle-trigger')) {
    const container = e.target.closest('.js-toggle-container')
    container.classList.toggle('toggle-on')

    if (container.classList.contains('toggle-on')) {
      const focusElement = container.querySelector('.js-toggle-focus-when-on')
      if (focusElement) {
        focusElement.focus()
      }
    }
  }

  if (e.target.closest('.js-menu-trigger')) {
    document.body.classList.toggle('menu-open')
  }
});

bind(document, 'change', (e) => {
  const element = e.target;

  if (!element.classList.contains('js-select-toggler')) {
    return false;
  }

  if (element) {
    let value = element.value;

    if (element.selectedIndex) {
      value = element[element.selectedIndex].value;
    }

    const selector = element.dataset.toggleSelector || element.id;

    const activeElements = document.querySelectorAll(`.js-toggled-by-selection[data-selector=${selector}][data-option=${value}]`)
    const inactiveElements = document.querySelectorAll(`.js-toggled-by-selection[data-selector=${selector}]:not([data-option=${value}])`)

    Array.from(inactiveElements).forEach((element) => {
      element.classList.add('toggled-off-by-selection');
    })

    Array.from(activeElements).forEach((element) => {
      element.classList.remove('toggled-off-by-selection');
    })
  }
});
